import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import {
  Form,
  Breadcrumb,
  Select,
  Button,
  Upload,
  Space,
  Spin,
  Tooltip,
  Input,
} from "antd";
import {
  UploadOutlined,
  DeleteOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import InputField from "../../common/htmlComponents/InputField";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as User } from "../../image/User.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import { ReactComponent as About } from "../../image/About.svg";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";

import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const { Option } = Select;

const AddMaterialCompany = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const MaterialId = id ? atob(id) : null;
  const formRef = useRef();

  const initialState = {
    company: CompanyId,
    category_tree: 1,
    material_type: null,

    short_description: null,
    long_description: null,
    unit_of_measurement: null,
    company_material_code: null,
    smart_buyer_code: null,
    // estimated_price: 0.0,
    estimated_price: 0,
  };
  // const initialState = {
  //   category_tree: 1,
  //   category_tree_name: "Cement",
  //   material_type: 39,
  //   material_type_name: "Iron rod",
  //   code: "8222",
  //   short_description: "Enter Dec",
  //   long_description: "Enter Long",
  //   // image": null,
  //   unit_of_measurement: 2,
  //   unit_of_measurement_name: "Bag",
  //   company_material_code: {
  //     company_material_code_id: null,
  //     company_material_code: null,
  //     company_estimated_unit_price: null,
  //   },
  // };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [uploadFile, setUploadFile] = useState("");
  const [categoryTree, setCategoryTree] = useState([]);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState([]);
  const [materialType, setMaterialType] = useState([]);
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [size, setSize] = useState(null);
  const [disable, setDisable] = useState(false);
  const [checkMaterialCodeId, setCheckMaterialCodeId] = useState(null);

  useEffect(() => {
    const materialGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(
          `material-master/get-material-by-company/?material_type_id=${MaterialId}`
        );
        console.log(apiResponse);
        if (apiResponse.data.results.success) {
          const {
            id,
            category_tree_name,
            material_type_name,
            code,

            ...filteredResponse
          } = apiResponse.data.results.data;
          setDisable(true);
          // setState(apiResponse.data.data);

          setState({
            ...filteredResponse,
            smart_buyer_code: apiResponse.data.results.data?.code,

            company_material_code:
              apiResponse.data.results.data.company_material_code
                .company_material_code,
            estimated_price:
              apiResponse.data.results.data.company_material_code
                .company_estimated_unit_price,
          });
          const object = {
            category_tree: 1,
            category_tree_name: "Cement",
            material_type: 39,
            material_type_name: "Iron rod",
            code: "8222",
            short_description: "Enter Dec",
            long_description: "Enter Long",
            image: null,
            unit_of_measurement: 2,
            unit_of_measurement_name: "Bag",
            company_material_code: {
              company_material_code_id: null,
              company_material_code: null,
              company_estimated_unit_price: null,
              // company_material_code_id: 32,
              // company_material_code: "ME23232",
              // company_estimated_unit_price: 2323,
            },
          };
          // setState({
          //   ...object,
          //   // smart_buyer_code: apiResponse.data.data?.code,
          //   company_material_code:
          //     object.company_material_code.company_material_code,
          // });
          setCheckMaterialCodeId(
            apiResponse.data.results.data.company_material_code
              .company_material_code_id
          );
          setFileLink(apiResponse.data.results.data.image);
          formRef.current.setFieldsValue({
            ...apiResponse.data.results.data,
            material_type: apiResponse.data.results.data.material_type
              ? apiResponse.data.results.data.material_type_name
              : null,
            company_material_code: apiResponse.data.results.data
              .company_material_code.company_material_code
              ? apiResponse.data.results.data.company_material_code
                  .company_material_code
              : null,
            estimated_price: apiResponse.data.results.data.company_material_code
              .company_estimated_unit_price
              ? apiResponse.data.results.data.company_material_code
                  .company_estimated_unit_price
              : null,
            smart_buyer_code: apiResponse.data.results.data.code,

            unit_of_measurement: apiResponse.data.results.data
              .unit_of_measurement
              ? apiResponse.data.results.data.unit_of_measurement_name
              : null,
            company: CompanyId,
          });
          // formRef.current.setFieldsValue({
          //   ...apiResponse.data.data,
          //   material_type: apiResponse.data.data.material_type
          //     ? apiResponse.data.data.material_type_name
          //     : null,
          //   company_material_code: apiResponse.data.data.company_material_code
          //     ? apiResponse.data.data.company_material_code
          //     : null,
          //   smart_buyer_code: apiResponse.data.data?.code
          //     ? apiResponse.data.data?.code
          //     : null,
          //   unit_of_measurement: apiResponse.data.data?.unit_of_measurement
          //     ? apiResponse.data.data?.unit_of_measurement_name
          //     : null,
          //   company: CompanyId,
          // });
          getMaterialTypeByCatagory(
            apiResponse.data.results.data.category_tree
          );
          setapiLoading(false);
        } else {
          ErrorNotificationMsg(t("error_in_list_material"));
        }
      } catch (error) {
        setapiLoading(false);
      }
    };
    if (MaterialId !== null) {
      materialGetById();
    }
  }, [MaterialId, t]);

  useEffect(() => {
    getCategoryTree();
    getUnitOfMeasurement();
  }, []);

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };
  const getUnitOfMeasurement = async (data) => {
    await getRequest("get-category-by-uom/?category_tree=1", data).then(
      (response) => {
        console.log(response.data.results.data);
        setUnitOfMeasurement(response.data.results.data);
        console.log(response, "responsessss");
      }
    );
  };
  const url = state.image;

  let filename = "";
  try {
    if (fileLink) {
      filename = url.split("/").pop();
    }
  } catch (e) {
    filename = "";
  }
  const handleEstimatedInputChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      estimated_price: value,
    }));
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const handleUnitOfMeasurement = async (value) => {
    setState({ ...state, unit_of_measurement: value });
  };
  const handleCategorySelectChange = async (value) => {
    setState({ ...state, category_tree: value, material_type: null });
    formRef.current.setFieldsValue({ material_type_name: null });
    setMaterialType([]);
    getMaterialTypeByCatagory(value);
  };

  const getMaterialTypeByCatagory = async (id) => {
    const materialTypeResponse = await getRequest(
      "material-type/?category_tree_id=" + id
    );

    setMaterialType(materialTypeResponse.data.results.data);
  };

  const uploadProps = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      setSize(file.size);
      if (file.size <= 2097152) {
        setUploadFile(file);
        setFileName(file.name);
      }
      return false;
    },
  };

  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      image: null,
    }));
    setUploadFile("");
    setFileName(null);
    setSize(null);
  };

  const handleFileDelete = async () => {
    const apiResponse = await deleteRequest(
      `material-master-image-delete54/${MaterialId}/`
    );
    if (apiResponse.data.success) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setFileLink(null);
      setFileName(null);
      setSize(null);
    }
  };

  const handleSubmit = async () => {
    setBtnLoading(true);

    const payloadAdd = {
      company: CompanyId,
      category_tree: state.category_tree,
      material_type: state.material_type,
      smart_buyer_code: state.smart_buyer_code,
      short_description: state.short_description,
      long_description: state.long_description,
      unit_of_measurement: state.unit_of_measurement,
      company_material_code: state.company_material_code,
      estimated_price: state.estimated_price,
    };
    const payloadEdit = {
      company: CompanyId,
      id: checkMaterialCodeId,
      category_tree: state.category_tree,
      material_type: state.material_type,
      smart_buyer_code: state.smart_buyer_code,
      short_description: state.short_description,
      long_description: state.long_description,
      unit_of_measurement: state.unit_of_measurement,
      company_material_code: state.company_material_code,
      estimated_price: state.estimated_price,
    };
    try {
      let apiResponse;

      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("image", uploadFile);
      if (checkMaterialCodeId !== null) {
        formData.append("form_data", JSON.stringify(payloadEdit));
      } else {
        formData.append("form_data", JSON.stringify(payloadAdd));
      }
      if (checkMaterialCodeId === null) {
        apiResponse = await postRequest(
          "company-material-code/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `company-material-code/${checkMaterialCodeId}/`,
          formData,
          customerHeaders
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          checkMaterialCodeId === null
            ? t("material_code_added_successfully")
            : t("material_code_updated_successfully")
        );
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        navigate("/company-material");
      } else {
        ErrorNotificationMsg(t("error_in_add_material_code"));
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add a new material to the procurement catalog.
                </span>
              }
            >
              <h3>{t("material")}</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/company-material"> {t("pl_material")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {checkMaterialCodeId
                  ? t("Edit Material")
                  : t("pl_add_material")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Row gutter={[15]}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="category_tree"
                    label={t("label_category_tree")}
                    prefix={<User />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_category_tree")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      allowClear
                      placeholder={t("pl_category_tree")}
                      optionFilterProp="children"
                      onChange={(value) => handleCategorySelectChange(value)}
                      disabled={disable}
                    >
                      {categoryTree.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="material_type_name"
                    label={t("pl_material_type")}
                    prefix={<User />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_select_material_type")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      disabled={disable}
                      showSearch
                      placeholder={t("pl_select_material_type")}
                      optionFilterProp="children"
                      onChange={(value) =>
                        handleSelectChange("material_type", value)
                      }
                    >
                      {materialType.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.type_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="smart_buyer_code"
                    label={t("est_label_code")}
                    placeholder={t("est_pl_code")}
                    // prefix={<Name />}
                    // rules={[{ required: true, message: t("val_code") }]}
                    handleInputChange={handleInputChange}
                    disabled={disable}
                  />
                </Col> */}

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="smart_buyer_code"
                    label={t("label_code")}
                    placeholder={t("pl_code")}
                    prefix={<Name />}
                    // rules={[{ required: true, message: t("val_code") }]}
                    handleInputChange={handleInputChange}
                    disabled={disable}
                  />
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="company_material_code"
                    label={t("label_erp_material")}
                    placeholder={t("pl_erp_material")}
                    prefix={<About />}
                    handleInputChange={handleInputChange}
                  />
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    label={t("label_estimated_price")}
                    name="estimated_price"
                    rules={[
                      {
                        pattern: /^\d+$/,
                        message: "Enter valid price",
                      },
                    ]}
                    // initialValue={state.gst_no}
                  >
                    <Input
                      placeholder={t("pl_estimated_price")}
                      value={state?.estimated_price}
                      // disabled={disableEstimatedValue}
                      // prefix={<RupeesSign />}
                      onChange={(e) =>
                        handleEstimatedInputChange(e.target.value)
                      }
                      max={15}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="short_description"
                    label={t("label_short_description")}
                    placeholder={t("pl_short_description")}
                    rules={t("val_short_description")}
                    prefix={<About />}
                    handleInputChange={handleInputChange}
                    disabled={disable}
                  />
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="long_description"
                    label={t("label_long_description")}
                    placeholder={t("pl_long_description")}
                    rules={t("val_long_description")}
                    prefix={<About />}
                    handleInputChange={handleInputChange}
                    disabled={disable}
                  />
                </Col>

                {/* <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="unit_of_measurement"
                    label={t("label_unit_of_measurement")}
                    prefix={<User />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_unit_of_measurement")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      allowClear
                      placeholder={t("label_unit_of_measurement")}
                      onChange={(value) =>
                        handleSelectChange("unit_of_measurement", value)
                      }
                      optionFilterProp="children"
                      disabled={disable}
                    >
                      <Select.Option value="m">m</Select.Option>
                      <Select.Option value="cm">cm</Select.Option>
                      <Select.Option value="mm">mm</Select.Option>
                      <Select.Option value="ft">ft</Select.Option>
                      <Select.Option value="in">in</Select.Option>
                      <Select.Option value="yd">yd</Select.Option>
                      <Select.Option value="kg">kg</Select.Option>
                      <Select.Option value="g">g</Select.Option>
                      <Select.Option value="mg">mg</Select.Option>
                      <Select.Option value="lb">lb</Select.Option>
                      <Select.Option value="oz">oz</Select.Option>
                      <Select.Option value="l">l</Select.Option>
                      <Select.Option value="ml">ml</Select.Option>
                      <Select.Option value="gal">gal</Select.Option>
                      <Select.Option value="qt">qt</Select.Option>
                      <Select.Option value="pt">pt</Select.Option>
                    </Select>
                  </Form.Item>
                </Col> */}
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="unit_of_measurement"
                    label={t("label_unit_of_measurement")}
                    prefix={<User />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_unit_of_measurement")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      disabled
                      // allowClear
                      placeholder={t("label_unit_of_measurement")}
                      optionFilterProp="children"
                      onChange={(value) => handleUnitOfMeasurement(value)}
                    >
                      {unitOfMeasurement.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.unit_of_measurement}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    className="BrowsButtonSec"
                    name="image"
                    label={t("label_image")}
                    prefix={<User />}
                    rules={[
                      {
                        required: false,
                        message: <Trans>{t("val_image")}</Trans>,
                      },
                    ]}
                  >
                    {size <= 2097152 && (
                      <>
                        <Space className="uploadedfile" size={[12, 16]}>
                          <a
                            href={fileLink}
                            className="link-color"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {fileLink ? filename : fileName}
                          </a>
                          {/* {fileLink && (
                            <DeleteOutlined onClick={handleFileDelete} />
                          )}
                          {fileName && (
                            <DeleteOutlined onClick={handleDelete} />
                          )} */}
                        </Space>
                      </>
                    )}

                    <Upload
                      placeholder="test"
                      className="BrowsButton"
                      {...uploadProps}
                      disabled={disable}
                    >
                      <Button
                        style={{ backgroundColor: "#F5F5F5" }}
                        icon={<StopOutlined />}
                      >
                        {t("upload_image")}
                      </Button>
                      <div className="condition">
                        {" "}
                        <p
                          style={{
                            color: size > 2097152 ? "red" : "GrayText",
                          }}
                        >
                          {t("upload_fileSize")} {t("upload_imagefileType")}
                        </p>
                      </div>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>

              <div className="FormFooter">
                <ButtonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={() => navigate("/company-material")}
                />

                <ButtonField
                  type="primary"
                  className="SaveGradiantBtn"
                  htmlType="Submit"
                  label={checkMaterialCodeId ? t("Edit") : t("Add")}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};

export default AddMaterialCompany;
